import * as ActionTypes from '../../actions'
import {
    Action,
    ViolationsType
} from "../../types";

const defaultState = {
    isLoading: true,
    hasError: false,
    violationsHistory: {},
    recentViolationsArray: [],
    rawData: []
};

export default function(state: ViolationsType = defaultState, action: Action) {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.FETCH_RECENT_VIOLATIONS: {
            return {
                ...state,
                isLoading: true,
                hasError: false
            };
        }
        case ActionTypes.FETCH_RECENT_VIOLATIONS_SUCCESS: {
            const { recentViolations, violationsHistory, rawData } = payload;

            // if (recentViolations && recentViolations.length > 20) {
            //     recentViolations.splice(0, recentViolations.length - 20);
            // }

            return {
                isLoading: false,
                hasError: false,
                recentViolationsArray: recentViolations && recentViolations.reverse(),
                violationsHistory,
                rawData
            };
        }
        case ActionTypes.FETCH_RECENT_VIOLATIONS_MESSAGE: {

            const { recentViolationsArray } = state;
            let { recentViolations } = payload;

            // console.log(recentViolations);

            recentViolations = recentViolations && recentViolations.reverse().concat(recentViolationsArray);

            // if (recentViolations && recentViolations.length > 20) {
            //     recentViolations.splice(20, recentViolations.length - 20);
            // }

            return {
                isLoading: false,
                hasError: false,
                recentViolationsArray: recentViolations
            };
        }
        case ActionTypes.FETCH_RECENT_VIOLATIONS_FAILURE: {
            return {
                ...state,
                isLoading: false,
                hasError: true
            };
        }
        default: {
            return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dashboard/recentViolations.ts